/* 布局 */
//前台
import Layout from "@views/layout";

const plagoodsclassRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "plagoodsclass/list",
        name: "PLAGOODSCLASS",
        meta: {
            title: "商品分类",
        },
        component: () => import("@views/business/plagoodsclass/index.vue"),
    },
        ],
};

export default plagoodsclassRouter;
